<app-help-header></app-help-header>
<main>
  <div class="content">
    <div class="container help-content">
      <div class="row">
        <div class="col-md-3">
          <app-help-menu class="hidden-sm"></app-help-menu>
        </div>
        <div class="col-md-9">
          <!-- PRO Solution -->
          <section #h_ProSolution [@fadeInAnimation]>
            <h3 translate id="item-3-2">PPC PRO Solution</h3>
            <div translate class="sum">
              The operation step for the PowerPanel Cloud PRO solution are as follows:
            </div>
            <div class="list" #h_ProSolution_Upgrade>
              <h5 translate>Upgrade to PPC PRO Account</h5>
              <div class="section">
                <ul>
                  <li translate>Upgrading your PPC account to PPC PRO requires assistance from the administration within CyberPower. Please contact them to initiate this process.</li>
                </ul>
              </div>
            </div>
            <div class="list" #h_ProSolution_ManagementFeature>
              <h5 translate>PPC PRO Management Feature</h5>
              <div class="section">
                <ul>
                  <li translate class="style_none">The PRO Management feature is exclusively accessible to PPC PRO account managers.</li>
                </ul>
                <ol>
                  <li>
                    <strong translate class="strong black">Overview:</strong><br>
                    <span translate>On the Overview page, account managers can view all abnormal devices flagged with warning and critical statuses. Clicking on any block provides quick navigation to
                      the corresponding page for more detailed information. </span>
                  </li>
                  <li>
                    <strong translate class="strong black">Company Management:</strong><br>
                    <span translate>Within the Company Management page, account managers can add new companies, monitor the device usage of each company, review the company hierarchy,
                      designate other account managers, and configure single sign-on (SSO) settings.</span>
                  </li>
                  <li>
                    <strong translate class="strong black">Account Management:</strong><br>
                    <span translate>In the Account Management section, account managers can manage all members within each company and modify their account authorities.</span>
                  </li>
                  <li>
                    <strong translate class="strong black">Device Management:</strong><br>
                    <span translate>On the Device Management page, account managers can check the status of devices and transfer devices to other companies.</span>
                  </li>
                  <li>
                    <strong translate class="strong black">Event Monitoring:</strong><br>
                    <span translate>The Event Monitoring page allows account managers to review all event logs for each company.</span>
                  </li>
                </ol>
              </div>
            </div>
            <div class="list" #h_ProSolution_AddMember>
              <h5 translate>Add Member to your company</h5>
              <div class="section">
                <ul>
                  <li translate>Navigate to <strong>Account Management</strong> and click "+ Edit Member". Enter the email address of the member you wish to add to this company and click "+"</li>
                  <li translate>If the email address is valid and can be added, it will appear below. </li>
                  <li translate>Click "Save" to finalize the process of adding the member.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-1.jpg">
                </div>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-2.jpg">
                </div>
                <div class="alert alert-warning">
                  <span translate>Note:</span>
                  <ol>
                    <li translate>The member's email must already be registered with PowerPanel Cloud. </li>
                    <li translate>The email domain (&#64;company.com) of the added member must match the company's domain to ensure they belong to the same company.</li>
                    <li translate>A member can only be associated with one company at a time. If a member needs to view devices from other companies, their browsing permissions can be adjusted by the
                      account manager.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="list" #h_ProSolution_EditCompany>
              <h5 translate>Edit Company</h5>
              <div class="section">
                <ul>
                  <li translate>Click "Edit" to modify the company name and select the account you wish to designate as the Account Manager.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-3.jpg">
                </div>
                <div class="alert alert-warning">
                  <span translate>Member roles:</span>
                  <ul>
                    <li translate>Account Manager: The administrator for the company, possessing the ability to add subsidiary companies, add or remove members, adjust member authority, and access PRO
                      management functions.</li>
                    <li translate>Device Manager: A device manager within the company, authorized to add, edit, and delete devices.</li>
                    <li translate>Viewer: A viewer can only access and view device information without any editing privileges.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="list" #h_ProSolution_CreateEmployeeCompany>
              <h5 translate>Create employee company</h5>
              <div class="section">
                <ul>
                  <li translate>Click "+ Add", enter the Company Name, and click "Save" to complete the creation. </li>
                  <li translate>After that, you can then refer to the above instructions to add members and make edits as needed.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-4.jpg">
                </div>
                <ul>
                  <li translate>Next, set up the hierarchy relationship of your company using the Company Hierarchy feature. </li>
                  <li translate>Click on a company within the tree structure, click "+ Add", and select the company you want to designate as a employee of this company. </li>
                  <li translate>Click "Save" to complete the setup. By default, the account manager of parent company will have access to view/edit devices in all child companies.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-5.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_ProSolution_Adddevices>
              <h5 translate>Add devices</h5>
              <div class="section">
                <ul>
                  <li translate class="style_none">Please follow the steps below to add a device:</li>
                  <li translate>Go to the Dashboard and click on the "+" icon.</li>
                  <li translate>Select "Add Device by Remote Cloud Card" and click “continue”.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-6.jpg">
                </div>
                <ul>
                  <li translate>Enter the MAC address and KEY of the device and choose the company to which the device belongs.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-7.jpg">
                </div>
                <ul>
                  <li translate>Click "Continue" and name the device.</li>
                  <li translate>Click "Continue" again to complete the process.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-8.jpg">
                </div>
                <ul>
                  <li translate>Additionally, you can filter devices belonging to a specific company by selecting the company name at the top.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-9.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_ProSolution_Addgroup>
              <h5 translate>Add group</h5>
              <div class="section">
                <ul>
                  <li translate class="style_none">We highly recommend creating different groups for each company to facilitate management. To create a group, follow the steps below:</li>
                  <li translate>Go to the Dashboard and click on the "+" icon.</li>
                  <li translate>Select "Add Group."</li>
                  <li translate>Enter the name of the group and select the time zone.</li>
                  <li translate>Choose the company and select the devices belonging to that company.</li>
                  <li translate>Click "Save" to complete the process.</li>
                  <li translate>You can also share the group or device with other accounts(up to three) for viewing by Device Settings.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-10.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_ProSolution_Devicetransfer>
              <h5 translate>Device transfer</h5>
              <div class="section">
                <ul>
                  <li translate class="style_none">PPC PRO provides account manager with the ability to transfer devices within the company hierarchy framework to accommodate organizational
                    adjustments and changes.</li>
                  <li translate>Click the 'Device transfer' button in the Device Management feature.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-11.jpg">
                </div>
                <ul>
                  <li translate>Select the company from which the device is to be transferred on the left, and choose the device to be transferred.</li>
                  <li translate>On the right, select the company to which the device is to be transferred, and upon completion of the selection.</li>
                  <li translate>Click "Save" to complete the device transfer.</li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-12.jpg">
                </div>
              </div>
            </div>
            <div class="list" #h_ProSolution_SingleSignOnlogin>
              <h5 translate>Single sign-on login</h5>
              <div class="section">
                <ul>
                  <li translate class="style_none">PowerPanel Cloud utilizes the SAML method provided by Microsoft Azure for enabling Single Sign-On (SSO). Follow the steps below to activate SSO:</li>
                  <li translate>Click on "Edit", select the "SSO" tab, and tick "Activate SSO". </li>
                </ul>
                <div class="img">
                  <img class="img-fluid" src="../../assets/images/help/help-pro-13.jpg">
                </div>
                <ul>
                  <li translate>Copy the “Identifier” and “Reply URL”.</li>
                  <li translate>Paste the copied information to the Single Sign-On with SAML page on Microsoft Azure. </li>
                  <li translate>Obtain the “Login URL” and download the certification (base 64). </li>
                  <li translate>Return to PowerPanel Cloud SSO settings page</li>
                  <li translate>Paste the Login URL, enter your domain and upload the certification. </li>
                  <li translate>Click “Save” to complete the process. </li>
                  <li translate>Use the “Login With SSO” button to login.</li>
                </ul>
              </div>
            </div>
          </section>
        </div>

      </div>
    </div>
  </div>
</main>
